import React from 'react'

type DraftMeta = { id: string; title: string; updated_at: string }

type Props = {
  onSaveDraft: () => void
  currentDraftId: string | null
  draftsList: DraftMeta[]
  onSelectDraft: (id: string) => void
  onDeleteDraft: () => void
  statusText?: string | null
  statusTone?: 'ok' | 'warn' | 'info'
}

export default function DraftControls({
  onSaveDraft,
  currentDraftId,
  draftsList,
  onSelectDraft,
  onDeleteDraft,
  statusText,
  statusTone = 'info',
}: Props) {
  const statusClass =
    statusTone === 'ok'
      ? 'text-emerald-300'
      : statusTone === 'warn'
      ? 'text-amber-300'
      : 'text-white/70'
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-sm">
      <button onClick={onSaveDraft} className="px-3 py-1.5 rounded bg-white/10 border border-white/15 hover:bg-white/15">Save draft</button>
      {statusText ? <span className={statusClass}>{statusText}</span> : null}
      <select
        value={currentDraftId || ''}
        onChange={(e)=> onSelectDraft(e.target.value)}
        className="min-w-[12rem] rounded bg-white/5 border border-white/10 px-2 py-1.5"
      >
        <option value="">Switch draft…</option>
        {draftsList.map((d) => (
          <option key={d.id} value={d.id}>{(d.title || 'Untitled').slice(0,60)} — {new Date(d.updated_at).toLocaleString()}</option>
        ))}
      </select>
      <button onClick={onDeleteDraft} disabled={!currentDraftId} className="px-3 py-1.5 rounded border border-white/15 hover:bg-white/5 disabled:opacity-50">Delete</button>
    </div>
  )
}
